import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "../../assets/css/slider.css";

const BannerComponent = () => {
  let navigate = useNavigate();

  const [tickerKey, setTickerKey] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTickerKey((prevKey) => prevKey + 1);
    }, 20000);

    return () => clearInterval(interval);
  }, []);

  const [inputTrack, setInputTrack] = useState();
  return (
    <div>
      {/* <div className="ticker-wrapper" key={tickerKey}>
        <div className="text-update">
          <p>
            Some deliveries may be delayed due to foggy weather.
            <span style={{ fontSize: "1rem", margin: "0 2%" }}>
              موسم دھند آلود ہونے کی وجہ سے کچھ ترسیلات میں تاخیر ہو سکتی ہے۔
            </span>
          </p>
        </div>
      </div> */}

      <div className="ticker-wrapper  overflow-hidden ">
        <div className="ticker">
          <div className="ticker__item">
            <p className="font-bold text-[12px]  ">
              Scammers are sending fake SMS & WhatsApp messages posing as
              representatives of delivery services. Please do not click on any
              such links. TCS SMS short code is 8591 & we never ask for payment
              via SMS or WhatsApp
              {/* <span style={{ fontSize: "1rem", margin: "0 2%" }}>
                گہری دھند نے کئی علاقوں کو اپنی لپیٹ میں لے لیا ہے جس کی وجہ سے
                حدِ نظرمیں مشکلات پیدا ہو رہی ہیں۔ یہ دھند ہمیں پریشان کر سکتی
                ہے لیکن یہ ہمیں روک نہیں سکتی! آپ کی خدمت کے لیے ہمارا عزم پختہ
                ہے اور ہم دن رات محنت کر رہے ہیں تاکہ آپ کی شپمنٹس بحفاظت اپنی
                منزل تک پہنچ سکیں۔ ٹی سی ایس کو منتخب کرنے کا شکریہ۔
              </span> */}
            </p>
          </div>
        </div>
      </div>

      <div
        id="banner-1"
        className="mobile-banner md:hidden flex hm-banner bg-center bg-no-repeat w-full justify-center items-center zoom"
      >
        <>
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
          >
            {/* <SwiperSlide>
              <img
                src="/Home/eid_banner_res.jpg"
                className="md:hidden flex"
                alt="fogEng"
              />
            </SwiperSlide> */}

            {/* <SwiperSlide>
              <img
                src="/Home/mobile-ramzan-banner.jpg"
                className="md:hidden flex"
                alt="fogEng"
              />
            </SwiperSlide> */}

            <SwiperSlide>
              <img
                src="/Home/responsive-banner1.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="/Home/responsive-banner2.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="/Home/responsive-banner3.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="/Home/responsive-banner4.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="/Home/responsive-banner5.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
          </Swiper>
        </>
        <div
          className="hidden sm:hidden lg:flex  lg:mt-[-5rem] md:mt-[-3rem]  sm:mt-[1rem] mt-[13rem] text-center md:text-left absolute"
          style={{ zIndex: 9 }}
        >
          <h2 className="banner-heading react-reveal text-white text-3xl sm:text-2xl font-semibold">
            Track Your Shipment
          </h2>
          <div className="banner-input react-reveal text-sm flex flex-col md:flex-row">
            <input
              onChange={(e) => {
                console.log(e);
                setInputTrack(e.target.value);
              }}
              type="number"
              placeholder="Enter your Tracking Number"
              className="p-3 md:w-[30rem] focus:outline-none opacity-75 rounded-l-sm"
              onKeyDown={(e) =>
                e?.key === "Enter" &&
                inputTrack &&
                navigate(`/track/${inputTrack}`)
              }
            />
            <button
              onClick={() => inputTrack && navigate(`/track/${inputTrack}`)}
              type="button"
              className="bg-[#D40511] text-white p-3 w-full md:w-[10rem] rounded-r-sm transition-all duration-500 gradientbg"
            >
              Track Shipment
            </button>
          </div>
        </div>
      </div>

      <div className="web-banner md:flex hidden hm-banner bg-center bg-no-repeat w-full flex justify-center items-center zoom">
        <>
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: false,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper "
          >
            {/* <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/eid_banner_web.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide> */}

            {/* <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/web-ramzan-banner.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide> */}

            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/sliderbanner1.jpg"
                className="lg:block hidden"
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner2.jpg"
                className="lg:flex hidden"
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner3.jpg"
                className="lg:flex hidden"
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/sliderbanner1.jpg"
                className="lg:block hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner2.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner3.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner5.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/banner-new.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
          </Swiper>
        </>
        <div
          className="hidden sm:block lg:mt-[-5rem] md:mt-[-3rem]  sm:mt-[1rem] mt-[13rem] text-center md:text-left absolute"
          style={{ zIndex: 9 }}
        >
          <h2 className="banner-heading react-reveal text-white text-3xl sm:text-2xl font-semibold">
            Track Your Shipment
          </h2>
          <div className="banner-input react-reveal text-sm flex flex-col md:flex-row">
            <input
              type="number"
              onChange={(e) => {
                setInputTrack(e.target.value);
              }}
              placeholder="Enter your Tracking Number"
              className="p-3 md:w-[30rem] focus:outline-none opacity-75 rounded-l-sm"
              onKeyDown={(e) =>
                e?.key === "Enter" &&
                inputTrack &&
                navigate(`/track/${inputTrack}`)
              }
            />
            <button
              onClick={() => inputTrack && navigate(`/track/${inputTrack}`)}
              type="button"
              className="bg-[#D40511] text-white p-3 w-full md:w-[10rem] rounded-r-sm transition-all duration-500 gradientbg"
            >
              Track Shipment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerComponent;
